import React, { Component, createRef } from "react";
import hljs from "highlight.js/lib/core";
import json from "highlight.js/lib/languages/json";
import "highlight.js/styles/github-dark.css"; // tu peux changer le thème ici
import { dateTimeValue } from "docx";

// Enregistre la coloration pour JSON
hljs.registerLanguage("json", json);

export default class JsonViewerClass extends Component {
  constructor(props) {
    super(props);
    this.codeRef = createRef();
  }

  componentDidMount() {
    this.highlight();
  }

  componentDidUpdate() {
    this.highlight();
  }

  highlight() {
    if (this.codeRef.current) {
      hljs.highlightElement(this.codeRef.current);
    }
  }

  render() {
    const { data, title = "JSON Viewer" } = this.props;
    if ("transcription" in data)
    {
      if (data.transcription.length > 200)
      {
        var datamin = [];
        for (var i=0; i < 200; i++)
          datamin.push (data.transcription[i]);
        data.transcription = datamin;
      }
    }

    if ("words" in data)
    {
      if (data.words.length > 200)
      {
        var datamin = [];
        for (var i=0; i < 200; i++)
          datamin.push (data.words[i]);
        data.words = datamin;
      }
    }



    return (
      <div
        style={{
          background: "#0d1117",
          color: "#c9d1d9",
          
          borderRadius: "0.75rem",
          fontFamily: "JetBrains Mono, Fira Code, monospace",
          boxShadow: "0 0 10px rgba(0,0,0,0.3)",
        }}
      >
        <pre style={{ margin: 0, overflowX: "auto" }}>
          <code ref={this.codeRef} className="language-json">
            {JSON.stringify(data, null, 2)}
          </code>
        </pre>
      </div>
    );
  }
}
